<template>
  <div class="ful-page">
    <div class="ful-page-wrapper">
      <!-- 顶部导航 -->
      <div class="ful-page-topnav">
        <button class="ful-btn-back" @click="goBack">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
          返回
        </button>
        <h1 class="ful-page-title">配送订单详情</h1>
      </div>

      <!-- 主卡片 -->
      <section class="ful-page-card">
        <!-- 状态头部 -->
        <OrderHeader
          :orderInfo="orderInfo"
          :countDownHour="countDownHour"
          :countDownMinute="countDownMinute"
          :countDownSecond="countDownSecond"
          :bare="true"
          @toPayPage="toPayPage"
          @applyRefund="applyRefund"
        >
          <template #status-icon>
            <svg v-if="isPaid" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            <svg v-else width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          </template>
        </OrderHeader>

        <!-- 双列内容区 -->
        <div class="ful-page-body">
          <!-- 左侧主区 -->
          <div class="ful-page-left">
            <!-- 物流 -->
            <ExpressInfo :orderInfo="orderInfo" :expressInfo="expressInfo" :bare="true">
              <template #content>
                <div class="ful-inner-section">
                  <div class="ful-inner-section-heading">
                    <span class="ful-inner-section-icon">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
                    </span>
                    <div>
                      <h2 class="ful-inner-section-title">物流配送</h2>
                    </div>
                  </div>
                  <div style="display:flex;flex-wrap:wrap;gap:12px;margin-bottom:12px">
                    <span v-if="orderInfo.expressName" style="display:inline-flex;align-items:center;gap:6px;border-radius:9999px;background:#eaf6f4;padding:6px 14px;font-size:18px;font-weight:700;color:#007e7f">{{ orderInfo.expressName }}</span>
                    <span v-if="orderInfo.expressNo" style="font-size:18px;color:#64748b;line-height:32px">物流单号：{{ orderInfo.expressNo }}</span>
                  </div>
                  <el-collapse v-if="expressInfo" v-model="expressActive" style="border:none">
                    <el-collapse-item name="1" style="border:none">
                      <template slot="title">
                        <div style="display:flex;align-items:center;gap:12px;width:100%;font-size:18px">
                          <span v-if="expressInfo.companyName" style="color:#304744;font-weight:600">{{ expressInfo.companyName }}：</span>
                          <span v-if="expressInfo.data" style="color:#304744;flex:1;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">{{ expressInfo.data[0].context }}</span>
                          <span v-else style="color:#94a3b8">暂无物流信息</span>
                          <span v-if="expressInfo.data" style="color:#94a3b8;font-size:18px">{{ expressInfo.data[0].time }}</span>
                        </div>
                      </template>
                      <div style="display:flex;flex-direction:column;gap:14px;padding:12px 0">
                        <div v-for="expr in expressInfo.data" :key="expr.time" style="border-left:2px solid #e2e8f0;padding-left:14px">
                          <div style="font-size:18px;color:#304744">{{ expr.context }}</div>
                          <div style="font-size:18px;color:#94a3b8;margin-top:3px">{{ expr.time }}</div>
                        </div>
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </template>
            </ExpressInfo>

            <!-- 配送订单信息（收件人 + 订单详情合并） -->
            <div class="ful-inner-section ful-delivery-section">
              <div class="ful-inner-section-heading ful-title-accent">
                <span class="ful-inner-section-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                </span>
                <div>
                  <h2 class="ful-inner-section-title">配送订单信息</h2>
                </div>
              </div>
              <!-- 收件人信息 -->
              <div class="ful-delivery-footer">
                <RecipientInfo :orderInfo="orderInfo" :bare="true" :showHeading="false" />
                <button v-if="showModifyAddress" class="ful-btn-edit" @click="modifyAddress">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  修改
                </button>
              </div>
              <!-- 订单详情 -->
              <div style="margin-top:20px;padding-top:20px;border-top:1px solid rgba(23, 61, 59,0.10)">
                <OrderDetailInfo :orderInfo="orderInfo" :bare="true" :showHeading="false" />
              </div>
            </div>

            <!-- 患者基本信息 -->
            <div class="ful-inner-section ful-order-accent">
              <PatientInfo :consultInfo="consultInfo" :bare="true" :chaoweiMode="isSuperfine" />
            </div>

            <!-- 症状信息（可折叠） -->
            <div class="ful-inner-section ful-order-accent">
              <SymptomTable
                :basicTableArray="basicTableArray"
                :shangjiaoTableArray="shangjiaoTableArray"
                :zhongjiaoTableArray="zhongjiaoTableArray"
                :xiajiaoTableArray="xiajiaoTableArray"
                :hasShangJiao="hasShangJiao"
                :hasZhongJiao="hasZhongJiao"
                :hasXiaJiao="hasXiaJiao"
                :bare="true"
                :chaoweiMode="isSuperfine"
              />
            </div>
          </div>

          <!-- 右侧侧边栏 -->
          <!-- <aside class="ful-sidebar-card">
            <div class="ful-sidebar-heading">
              <span class="ful-inner-section-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
              </span>
              <div>
                <p class="ful-inner-section-eyebrow">Order summary</p>
                <h2 class="ful-inner-section-title">本次配送</h2>
              </div>
            </div>
            <div style="display:flex;flex-direction:column;gap:14px;font-size:14px">
              <div class="ful-sidebar-row">
                <span class="label">处方名称</span>
                <span class="value">{{ orderInfo.typeText || '-' }}</span>
              </div>
              <div class="ful-sidebar-row">
                <span class="label">药材数量</span>
                <span class="value">{{ tablePrescription.count || 0 }} 味 · {{ tablePrescription.totalWeight || 0 }} 克</span>
              </div>
              <div class="ful-sidebar-row">
                <span class="label">配送费用</span>
                <span class="value price">¥ {{ orderInfo.sumPrice || '0.00' }}</span>
              </div>
              <div class="ful-sidebar-divider">
                <div class="ful-sidebar-row">
                  <span class="label">订单状态</span>
                  <span :class="['value', 'status', isPaid ? 'paid' : 'unpaid']">{{ isPaid ? '已支付，等待配送' : '等待支付确认' }}</span>
                </div>
              </div>
            </div>
          </aside> -->
        </div>

        <!-- 底部药品表 -->
        <div class="ful-page-bottom">
          <div class="ful-inner-section-heading ful-title-accent">
            <span class="ful-inner-section-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 14l2 2 4-4"/></svg>
            </span>
            <div>
              <h2 class="ful-inner-section-title"> {{ orderInfo.typeText || '' }}</h2>
            </div>
          </div>
          <DrugTable :tablePrescription="tablePrescription" :orderInfo="orderInfo" :bare="true"
            :supplyDays="tablePrescription.supplyDays" :showSupplyDays="true" :chaoweiMode="isSuperfine" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
let un_pay_status = "0"; //未支付
let payed_status = "1"; //已支付
let order_avaliable_status = "2"; //订单生效
let prescripting_status = "3"; //配药中
let expressing_status = "4"; //配送中
let paying_status = "99"; //配送中
let express_complete_status = "5"; //配送完成
import AreaHeader from "@/components/widgets/area-header.vue";
import OrderHeader from "@/components/fulfillment/common/OrderHeader.vue";
import ExpressInfo from "@/components/fulfillment/common/ExpressInfo.vue";
import RecipientInfo from "@/components/fulfillment/common/RecipientInfo.vue";
import OrderDetailInfo from "@/components/fulfillment/common/OrderDetailInfo.vue";
import PatientInfo from "@/components/fulfillment/common/PatientInfo.vue";
import SymptomTable from "@/components/fulfillment/common/SymptomTable.vue";
import DrugTable from "@/components/fulfillment/common/DrugTable.vue";
import { EventBus } from "../../js/eventbus.js";
export default {
  name: "fulOrder",
  components: {
    AreaHeader,
    OrderHeader,
    ExpressInfo,
    RecipientInfo,
    OrderDetailInfo,
    PatientInfo,
    SymptomTable,
    DrugTable,
  },
  data() {
    return {
      orderInfo: {},
      activeNames: "0",
      activeNames1: "1",
      countDownHour: "00",
      countDownMinute: "00",
      countDownSecond: "00",
      tablePrescription: {},
      expressInfo: {},
      basicTableArray: [],
      shangjiaoTableArray: [],
      zhongjiaoTableArray: [],
      xiajiaoTableArray: [],
      consultInfo: {},
      expressActive: '0',
      hasShangJiao: false,
      hasZhongJiao: false,
      hasXiaJiao: false,
    };
  },
  computed: {
    isPaid() {
      return this.orderInfo.status != 0 && this.orderInfo.status != 99
    },
    showModifyAddress() {
      return (
        this.orderInfo.status == 0 ||
        this.orderInfo.status == 99 ||
        (this.orderInfo.status > 0 && this.orderInfo.refundFlag == 'Y')
      );
    },
    // 是否为超微饮片处方（控制 PatientInfo / SymptomTable / DrugTable 的字段文案）
    isSuperfine() {
      if (!this.orderInfo) return false
      var t = this.orderInfo.type || this.orderInfo.prescriptionType || ''
      if (typeof t === 'string' && t.indexOf('_superfine_prescription') !== -1) return true
      var text = (this.orderInfo.typeText || '').toString()
      if (text.indexOf('超微') !== -1) return true
      return false
    }
  },
  mounted() {
    console.log("fulfillmentOrder mounted");
    this.orderId = this.$route.query.orderId;
    this.getOrderInfo();
    var address = sessionStorage.getItem("selectAddress");
    // 获取我的地址
    if (address != null && address.length > 0) {
      console.log("address:" + address);
      var addressObj = JSON.parse(address);
      sessionStorage.removeItem("selectAddress");
      this.wjtHttp.post(
        this,
        "/api/delivery/order/modify/address",
        {
          deliveryOrderId: this.orderId,
          recipientAddress:
            addressObj.province +
            addressObj.city +
            addressObj.county +
            addressObj.street,
          recipientName: addressObj.receiverName,
          recipientPhone: addressObj.phoneNo,
        },
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.$message("地址修改成功");
            this.getOrderInfo();
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0 ? data.msg : "修改地址异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  },
  methods: {
    shouldShowTime(hour, minute) {
      return !(this.isEmptyValue(hour) && this.isEmptyValue(minute));
    },
    isEmptyValue(value) {
      return value === '' || value === null || value === undefined;
    },
    formatTimeValue(value) {
      if (value === '-1' || value === -1 || value === '--') {
        return '--';
      }
      return value;
    },
    goBack() {
      this.$router.go(-1);
    },
    getOrderInfo() {
      this.wjtHttp.get(
        this,
        "/api/delivery/order/info/" + this.orderId,
        {},
        true,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.orderInfo = data.data;
            if (this.orderInfo.status == un_pay_status) {
              this.startCountDown(data.data.payCountdown);
            }
            if (data.data.status == paying_status) {
              console.log(11111);
            } else if (data.data.status >= expressing_status) {
              this.getExpressInfo(this.orderId);
            }

            this.consultInfo = data.data.patient;
            this.generateTableData();
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0 ? data.msg : "获取订单详情异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getExpressInfo(orderId) {
      this.wjtHttp.get(
        this,
        "/api/delivery/progress/" + orderId,
        {},
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.expressInfo = data.data;
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0 ? data.msg : "获取订单详情异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    startCountDown(timeMill) {
      var currentTimeMill = Date.parse(new Date());
      console.log("netMill:" + timeMill);
      console.log("currentMill:" + currentTimeMill);
      if (currentTimeMill > timeMill) {
        return;
      }
      var totalSecond = (timeMill - currentTimeMill) / 1000;

      clearInterval(this.interval);
      var that = this;
      this.interval = setInterval(function () {
        console.log("countdown:" + totalSecond);
        // 秒数
        var second = totalSecond;

        // 小时位
        var hr = Math.floor(second / 3600);
        var hrStr = hr.toString();
        if (hrStr.length == 1) hrStr = "0" + hrStr;

        // 分钟位
        var min = Math.floor((second - hr * 3600) / 60);
        var minStr = min.toString();
        if (minStr.length == 1) minStr = "0" + minStr;

        // 秒位
        var sec = second - hr * 3600 - min * 60;
        var secStr = sec.toString();
        if (secStr.length == 1) secStr = "0" + secStr;
        console.log("hour:" + hrStr);
        console.log("minite:" + minStr);
        console.log("second:" + secStr);
        that.countDownHour = hrStr;
        that.countDownMinute = minStr;
        that.countDownSecond = secStr;
        totalSecond--;
        if (totalSecond < 0) {
          clearInterval(that.interval);
          console.log("倒计时结束");
          that.countDownHour = "00";
          that.countDownMinute = "00";
          that.countDownSecond = "00";
          that.getOrderInfo();
        }
      }, 1000);
    },
    generateTableData() {
      // 兼容两种数据结构：
      // 1. orderInfo.prescriptionInfo.prescription (旧)
      // 2. orderInfo.prescription (新，prescription 字段直接为开方信息)
      var item = this.orderInfo.prescriptionInfo || this.orderInfo
      // 深拷贝处方数组，避免修改原始接口数据
      var rawArray = item.prescription || this.orderInfo.prescription || []
      var itemArray = rawArray.map(function (drug) { return Object.assign({}, drug) })
      // 构建成对后的 options 数组（每行2个药品）
      var options = []
      for (var k = 0; k < itemArray.length; k++) {
        if (k % 2 === 0) {
          var pair = Object.assign({}, itemArray[k])
          var right = itemArray[k + 1]
          if (right && right.key != null && right.key !== '' && right.value !== undefined && right.value !== null && right.value !== '') {
            pair.key1 = right.key
            pair.value1 = right.value
            pair.index1 = right.index
          }
          options.push(pair)
        }
      }
      // Vue 2 无法检测对象新属性添加，必须用整体替换确保响应式
      this.tablePrescription = {
        count: item.count,
        charge: item.charge,
        totalWeight: item.totalWeight,
        startDate: item.startDate,
        endDate: item.endDate,
        supplyDays: item.supplyDays,
        title: item.name,
        prescription: itemArray,
        options: options
      }

      var inquiryInfo = this.orderInfo.inquiryInfo || {}
      this.basicTableArray = this.basicTableArray.concat(
        inquiryInfo.basic_array || []
      )
      this.basicTableArray = this.basicTableArray.concat(
        inquiryInfo.basic_enter_array || []
      )
      this.basicTableArray = this.basicTableArray.concat(
        inquiryInfo.maixiang_array || []
      )
      this.shangjiaoTableArray = inquiryInfo.shangjiao_array || []
      this.zhongjiaoTableArray = inquiryInfo.zhongjiao_array || []
      this.xiajiaoTableArray = inquiryInfo.xiajiao_array || []
      var that = this
      this.shangjiaoTableArray.forEach(function (element) {
        if (element && element.value && element.value.length > 0) {
          that.hasShangJiao = true
        }
      })
      this.zhongjiaoTableArray.forEach(function (element) {
        if (element && element.value && element.value.length > 0) {
          that.hasZhongJiao = true
        }
      })
      this.xiajiaoTableArray.forEach(function (element) {
        if (element && element.value && element.value.length > 0) {
          that.hasXiaJiao = true
        }
      })
    },
    toPayPage() {
      sessionStorage.setItem(
        "fulfillmentPlaceOrderInfo",
        JSON.stringify(this.orderInfo)
      );
      this.$router.push("/wjtpay");
    },
    modifyAddress() {
      this.$router.push({
        path: "/address",
        query: {
          mode: 1,
        },
      });
    },
    applyRefund() {
      this.wjtHttp.post(
        this,
        "/api/adapay/v1/refund ",
        { deliveryOrderId: this.orderInfo.deliveryOrderId },
        false,
        (res) => {
          var data = res.data;
          if (data.code == 200) {
            this.$message("操作成功");
            this.getOrderInfo();
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0 ? data.msg : "获取订单详情异常",
              type: "error",
            });
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
  destroyed() {
    clearInterval(this.interval);
    EventBus.$off("address", null);
  },
};
</script>

<style scoped>
/* 布局依赖 fulfillment-common.css 中的 ful-* 类 */

/* 患者基本信息 / 症状信息：参考 PrescriptionResultPage 的绿色竖线 + 标题样式 */
.ful-order-accent >>> .ful-inner-section-icon,
.ful-order-accent >>> .ful-inner-section-eyebrow {
  display: none;
}
.ful-order-accent >>> .ful-inner-section-title {
  position: relative;
  padding-left: 16px;
  font-family: '思源黑体', 'Source Han Sans SC', 'Noto Sans SC', system-ui, sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #304744;
}
.ful-order-accent >>> .ful-inner-section-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  border-radius: 2px;
  background: #009798;
}
.ful-order-accent >>> .ful-inner-section-heading {
  margin-bottom: 16px;
}

/* 配送订单信息 + 底部药品表标题：去掉绿色图标块，标题改为绿色竖线 */
.ful-title-accent > .ful-inner-section-icon {
  display: none;
}
.ful-title-accent .ful-inner-section-title {
  position: relative;
  padding-left: 16px;
  font-family: '思源黑体', 'Source Han Sans SC', 'Noto Sans SC', system-ui, sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: #304744;
  margin: 0;
}
.ful-title-accent .ful-inner-section-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  border-radius: 2px;
  background: #009798;
}

/* 配送订单信息：参考患者基本信息的 label/value 卡片样式 */
.ful-delivery-section >>> .ful-info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 4px 0;
}
.ful-delivery-section >>> .ful-info-grid > div {
  display: flex;
  align-items: center;
  border: 1px solid #edf0ec;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 18px;
  line-height: 1.5;
  background: #fff;
}
.ful-delivery-section >>> .ful-info-label {
  color: #1a1a1a;
  flex-shrink: 0;
  font-size: 18px;
  min-width: 110px;
}
.ful-delivery-section >>> .ful-info-value {
  color: #1a1a1a;
  font-size: 18px;
  word-break: break-all;
}
@media (max-width: 640px) {
  .ful-delivery-section >>> .ful-info-grid {
    grid-template-columns: 1fr;
  }
}

/* 移动端适配 */
@media (max-width: 640px) {
  .container { width: 100%; }
}
</style>
